import { useEffect, useState } from 'react';
import { useBargain } from 'app/BargainWidget/context/BargainContext';

const useCountDown = () => {
  const { bargainData, widgetSettings } = useBargain();
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    if (!widgetSettings?.showCountDown || !bargainData?.startTime || !bargainData?.endTime) return;

    const calculateTimeLeft = () => {
      const now = Date.now();
      const startTime = new Date(bargainData?.startTime).getTime();
      const endTime = new Date(bargainData?.endTime).getTime();

      if (isNaN(startTime) || isNaN(endTime)) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      let targetTime;

      if (now < startTime) {
        // Event has NOT started → Count down to start
        targetTime = startTime;
      } else if (now < endTime) {
        // Event is ongoing → Count down to end
        targetTime = endTime;
      } else {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const distance = targetTime - now;
      setCountdown({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [bargainData?.startTime, bargainData?.endTime, widgetSettings?.showCountDown]);

  return { countdown };
};

export default useCountDown;
